export default "/images/vendor/flag-icon-css/flags/1x1/kh.svg?695ec7a1a39090e600d533a38c5db55c";